module.exports = __webpack_public_path__ + "static/media/hook-login-background-2.ff482b54.jpg";